import { Dispatch } from 'redux';
import { OrderResponse } from '../../api/models/order';
import { CheckoutState } from '../../state';
import { updateOrderAction as plainUpdateOrderAction } from './actions';

export const updateOrderAction =
    (orderResponse: OrderResponse) =>
    (
        dispatch: Dispatch<any>,
        getState: () => Pick<CheckoutState, 'survey' | 'order'>,
    ) =>
        dispatch(plainUpdateOrderAction(orderResponse, getState()));
